/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Administration {
    import fld = ItemDiscountDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ItemDiscountDetailsEditor extends Common.GridEditorBase<ItemDiscountDetailsRow> {
        protected getColumnsKey() { return "Administration.ItemDiscountDetails"; }
        protected getDialogType() { return ItemDiscountDetailsDialog; }
        protected getLocalTextPrefix() { return ItemDiscountDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        public CategoryId: number;
        typeid: number;
        private pendingChanges: Q.Dictionary<any> = {};
        private rowSelection = new Serenity.GridRowSelectionMixin(this);

        constructor(container: JQuery) {
            super(container);
            var x = 0;
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        }
        public getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            
            var Type = Q.first(columns, x => x.field === fld.CategoryId);
            Type.referencedFields = [fld.CategoryId];
            Type.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.CategoryId, OMS.CategoryMasterRow.getLookup(), this);

            var SubType = Q.first(columns, x => x.field === fld.SubCategoryId);
            SubType.referencedFields = [fld.SubCategoryId];
            SubType.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.SubCategoryId, OMS.SubCategoryMasterRow.getLookup(), this);

            var BaseItem = Q.first(columns, x => x.field === fld.ProductTypeId);
            BaseItem.referencedFields = [fld.ProductTypeId];
            BaseItem.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.ProductTypeId, Q.getLookup<OMS.ProductTypeRow>('Jewellery'), this);

            Q.first(columns, x => x.field === fld.MaxDiscount).format = amt;

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
              
            }

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.MaxDiscount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            if (field === fld.MaxDiscount && value >= 0) {
                item[field] = value;
            }

            if (field === fld.ProductTypeId && value >= 0) {
                item[field] = value;

            }
            if (field === fld.CategoryId && value > 0) {
                this.CategoryId = value;
                item[field] = value;

            }
            if (field === fld.SubCategoryId && value > 0) {
                item[field] = value;

            }
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }



        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProductSelectGrid;
            buttons = buttons.filter(x => x.cssClass != "add-button");
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Add New",
                cssClass: "",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    var item: ItemDiscountDetailsRow = {
                        ProductTypeId: OMS.ProductTypeRow.getLookup().items[0].ProductTypeId,
                        CategoryId: OMS.CategoryMasterRow.getLookup().items[0].CategoryId,
                        SubCategoryId: OMS.SubCategoryMasterRow.getLookup().items[0].SubCategoryId,
                        MaxDiscount:0,
                    }
                    item[this.getIdProperty()] = "`" + this.nextId++;
                    this.view.addItem(item);

                    // #endregion
                }
            });

            return buttons;
        }
    }
}